/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { UserConcernAndDiagnosisKarteFragmentDoc } from '../UserConcernAndDiagnosis/UserConcernAndDiagnosis.generated';
export type Channel =
  /** 中国銀行 */
  | 'CHUGOKU_GINKO'
  /** ファミペイ */
  | 'FAMIPAY'
  /** 400F */
  | 'FOUR_HUNDRED_F'
  /** 400F 保険比較 */
  | 'FOUR_HUNDRED_F_INSURANCE_COMPARISON'
  /** はなさく生命 */
  | 'HANASAKU'
  /** ほけんの窓口 */
  | 'HOKEN_NO_MADOGUCHI'
  /** JCB */
  | 'JCB'
  /** ゆうちょ銀行 */
  | 'JP_BANK'
  /** きらぼし銀行 */
  | 'KIRABOSHI'
  /** ライフプラザパートナーズ */
  | 'LIFE_PLAZA'
  /** メットライフ生命 */
  | 'MET_LIFE'
  /** みんかぶ */
  | 'MINKABU'
  /** マネーフォワード */
  | 'MONEY_FORWARD'
  /** ninpath */
  | 'NINPATH'
  /** ニッセイアセットマネジメント */
  | 'NISSEI_AM'
  /** オカネコ */
  | 'OKANEKO'
  /** オカネコ転職 */
  | 'OKANEKO_TENSHOKU'
  /** OKB */
  | 'OKB'
  /** オリックス銀行 */
  | 'ORIX_BANK'
  /** Ponta */
  | 'PONTA'
  /** 楽天証券 */
  | 'RAKUTEN'
  /** 楽天証券インハウスアドバイザー */
  | 'RAKUTEN_IN_HOUSE_ADVISOR'
  /** 楽天証券の運用相談 */
  | 'RAKUTEN_UNYOU_SOUDAN'
  /** SBI証券 */
  | 'SBI'
  /** SBIマネープラザ */
  | 'SBI_MONEY_PLAZA'
  /** SBI証券の運用相談 */
  | 'SBI_UNYOU_SOUDAN'
  /** 三井住友カード */
  | 'SMCC'
  /** トヨタカローラ */
  | 'TOYOTA_COROLLA'
  /** Vitalityスマート */
  | 'VITALITY_SMART'
  /** Yahoo! JAPAN */
  | 'YAHOO'
  /** 財形住宅金融 */
  | 'ZAIKEI_JUTAKU_KINYU';

export type UserConcernAndDiagnosisModalKarteFragment = { id: string, userComment: string, numberOfPlannerComments: number, hasCommentsFromPlannersBelongingToSameBranch: boolean, modifiedAt: TimeString, channel: Types.Channel, ownKartePlannerComment: { comment: string | null } | null, topics: Array<{ id: string, name: string }> };

export const UserConcernAndDiagnosisModalKarteFragmentDoc = gql`
    fragment UserConcernAndDiagnosisModalKarte on Karte {
  ...UserConcernAndDiagnosisKarte
}
    ${UserConcernAndDiagnosisKarteFragmentDoc}`;